/**
 * What the Goods Receipting "Received Qty" column must show.
 * Prefer receipting.updatedQuantity (actual received). Never prefer
 * previousQty — that field is audit/history and can be stale or negative
 * (e.g. updatedQuantity=6 still displayed previousQty=-4).
 */
export function resolveReceivedQuantityDisplay(record = {}) {
  if (record?.status === 'Rejected by supplier') {
    const rejected = Number(record.quantity)
    return Number.isFinite(rejected) ? rejected : 0
  }

  const fromReceipting = Number(record?.receipting?.updatedQuantity)
  if (
    record?.receipting?.updatedQuantity != null &&
    record?.receipting?.updatedQuantity !== '' &&
    Number.isFinite(fromReceipting)
  ) {
    return fromReceipting
  }

  const fromOrderUpdated = Number(record?.updatedQuantity)
  if (
    record?.updatedQuantity != null &&
    record?.updatedQuantity !== '' &&
    Number.isFinite(fromOrderUpdated)
  ) {
    return fromOrderUpdated
  }

  const fromQuantity = Number(record?.quantity)
  return Number.isFinite(fromQuantity) ? fromQuantity : 0
}
